// extracted by mini-css-extract-plugin
module.exports = {"notFoundImage":"NotFound_notFoundImage__QvOeP","downforButton":"NotFound_downforButton__ZZh_r"};